import { h } from "vue";
import CountryFlag from "@/components/CountryFlag.vue";
import { eventsWithTeam, eventsWithTournament } from "./routes";

export const CUSTOM_ISO_COUNTRIES = [
  {
    tournament_ids: ["5ff59a93395543bbadc3a91c1559e2e4_trn"],
    label: "Scotland",
    icon: h(CountryFlag, { code: "SCT", class: "shadow-md" }),
    flag: "SCT",

    items: [
      {
        label: "Teams",
        items: [
          {
            label: "Celtic FC",
            to: eventsWithTeam("celtic", { iso_country: "GBR", sport_type: "football" }),
          },
          {
            label: "Aberdeen FC",
            to: eventsWithTeam("aberdeen", { iso_country: "GBR", sport_type: "football" }),
          },
        ],
      },
      {
        label: "Tournaments",
        items: [
          {
            label: "Scottish Premiership",
            to: eventsWithTournament("scottish-premiership-2627", { iso_country: "GBR", sport_type: "football" }),
          },
        ],
      },
    ],
    to: eventsWithTournament("scottish-premiership-2627", { iso_country: "GBR", sport_type: "football" }),
  },
];
